import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {loadModules, setDefaultOptions} from 'esri-loader'
import ArcGIS from 'terraformer-arcgis-parser'
import Terraformer from 'terraformer'
import WKT from 'terraformer-wkt-parser'
import {Feature, Geometry, Properties, featureCollection, bbox, bboxPolygon, buffer, 
        point as turfPoint, lineString as turfLineString, polygon as turfPolygon } from '@turf/turf';
const MapOneLicense = (props: any) => {
  // console.log('props MAPA', props)
  setDefaultOptions({css: true})
  const styles = {
    container: {
      height: '70vh',
    },
    mapDiv: {
      height: '69vh',
      border: '3px solid #ccc',
      background: '#ccc',
      borderRadius: '10px',
    },
  }

  const navigate = useNavigate()

  useEffect(() => {
    loadModules([
        "esri/widgets/Sketch",
        "esri/Map",
        "esri/layers/GraphicsLayer",
        "esri/views/MapView",
        "esri/geometry/Extent",
        "esri/geometry/SpatialReference",
        "esri/Graphic",
        "esri/geometry/Point",
        "esri/geometry/Polyline",
        "esri/geometry/Polygon",
        "esri/geometry/geometryEngine",
        "esri/widgets/Fullscreen",
        "esri/layers/FeatureLayer",
        "esri/widgets/Expand",
        "esri/widgets/BasemapGallery",
        "esri/renderers/SimpleRenderer",
        "esri/symbols/SimpleMarkerSymbol",
        "esri/Color",
        "esri/symbols/Font",
        "esri/symbols/TextSymbol",
        "esri/config",
        "esri/renderers/UniqueValueRenderer",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/widgets/Legend",
        "esri/widgets/Search"
    ])
      .then(([Sketch, Map, GraphicsLayer, MapView, Extent, SpatialReference, Graphic, Point, Polyline, Polygon, 
        geometryEngine, Fullscreen, FeatureLayer, Expand, BasemapGallery, SimpleRenderer, SimpleMarkerSymbol, Color, Font, TextSymbol, esriConfig, UniqueValueRenderer,
        SimpleFillSymbol, SimpleLineSymbol, Legend, Search]) => {
    
        
        // criação do mapa
        const map = new Map({
          basemap: 'hybrid'
        })

        // criação da view
        const view = new MapView({
          container: 'viewDiv',
          map: map,
          zoom: 4,
          center: [0, 0],
        })

        let startExtent = new Extent({
            xmin: -73.9872354804,
            ymin: -33.7683777809,
            xmax: -34.7299934555,
            ymax: 5.24448639569,
            spatialReference: new SpatialReference({ wkid:4326 })
        });

        view.extent = startExtent;
        
        let fullscreen = new Fullscreen({
            view: view
        });
        view.ui.add(fullscreen, "top-left");

        const basemapGallery = new BasemapGallery({
            view: view,
            container: document.createElement("div")
        });

        let bgExpand = new Expand({
            view: view,
            content: basemapGallery
        });

        view.ui.add(bgExpand, "top-left");

        ///////////////////////////////////////////////////////////////////////
        //                              Symbols
        ///////////////////////////////////////////////////////////////////////

        let simboloPadraoPonto = {
            type: "simple-marker",
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
            color: "#187bcd",
            size: 24,
        };

        // let simboloPadraoLinha = {
        //     type: "simple-marker",
        //     path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
        //     color: "#187bcd",
        //     size: 24,
        // };

        // let simboloPadraoPoligono = {
        //     type: "simple-marker",
        //     path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
        //     color: "#187bcd",
        //     size: 24,
        // };

        let pointUniqueValueInfo = [
            {
                value: "vencida",
                label: "Vencida",
                symbol: {
                    type: "simple-marker",
                    path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                    color: "red",
                    size: 24,
                }
            },
            {
                value: "em_dia",
                label: "Em Dia",
                symbol: {
                    type: "simple-marker",
                    path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                    color: "green",
                    size: 24,
                }
            },
            {
                value: "vencendo",
                label: "Vencendo",
                symbol: {
                    type: "simple-marker",
                    path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                    color: "yellow",
                    size: 24,
                }
            }
        ];


        ///////////////////////////////////////////////////////////////////////
        //                              Labels
        ///////////////////////////////////////////////////////////////////////

        const labelClassPoint = {
            symbol: {
                type: "text",
                color: "#ffffff",
                font: {
                    family: "Arial",
                    size: 12,
                    weight: "normal"
                },
                haloColor: "#000000",
                haloSize: 2,
            },
            labelPlacement: "below-center",
            labelExpressionInfo: {
                expression: "$feature.nome"
            },
        };

        const labelClassLine = {
            symbol: {
                type: "text",
                color: "#ffffff",
                font: {
                    family: "Arial",
                    size: 12,
                    weight: "normal"
                },
                haloColor: "#000000",
                haloSize: 2,
            },
            labelPlacement: "center-along",
            labelExpressionInfo: {
                expression: "$feature.nome"
            },
        };

        const labelClassPolygon = {
            symbol: {
                type: "text",
                color: "#ffffff",
                font: {
                    family: "Arial",
                    size: 12,
                    weight: "normal"
                },
                haloColor: "#000000",
                haloSize: 2,
            },
            labelPlacement: "always-horizontal",
            labelExpressionInfo: {
                expression: "$feature.nome"
            },
        };

        ///////////////////////////////////////////////////////////////////////
        //                           Add Installarions
        ///////////////////////////////////////////////////////////////////////

        let pointGraphs = [];
        let lineGraphs = [];
        let polygonGraphs = [];
        let turf_features: Feature<Geometry, Properties>[] = [];
        let installations = props.enterprises;
        
        for(let i=0; i<installations.length; i++){

            let installation = installations[i];
            if(installation.geom_point){
                let geojson = WKT.parse(installation.geom_point);
                let arcgisPoint: any = ArcGIS.convert(geojson);
                arcgisPoint.type = "point";

                pointGraphs.push({
                    geometry: arcgisPoint,
                    attributes: {
                        ObjectID: i,
                        id: installation.id,
                        uuid: installation.uuid,
                        nome: installation.name,
                        activity_type: installation.enterprise_type.description,
                        activity_type_id: installation.enterprise_type.id
                    }
                });
                turf_features.push(turfPoint([arcgisPoint.x, arcgisPoint.y], {"nome": installation.name}));
            }
            else if(installation.geom_line){
                let geojson = WKT.parse(installation.geom_line);
                let arcgisLine: any = ArcGIS.convert(geojson);
                arcgisLine.type = "polyline";

                lineGraphs.push({
                    geometry: arcgisLine,
                    attributes: {
                        ObjectID: i,
                        id: installation.id,
                        uuid: installation.uuid,
                        nome: installation.name,
                        activity_type: installation.enterprise_type.description,
                        activity_type_id: installation.enterprise_type.id
                    }
                })
                turf_features.push(turfLineString(arcgisLine.paths[0], {"nome": installation.name}));
            }
            else if(installation.geom_polygon){
                let geojson = WKT.parse(installation.geom_polygon);
                let arcgisPolygon: any = ArcGIS.convert(geojson);
                arcgisPolygon.type = "polygon";

                polygonGraphs.push({
                    geometry: arcgisPolygon,
                    attributes: {
                        ObjectID: i,
                        id: installation.id,
                        uuid: installation.uuid,
                        nome: installation.name,
                        activity_type: installation.enterprise_type.description,
                        activity_type_id: installation.enterprise_type.id
                    }
                })
                turf_features.push(turfPolygon(arcgisPolygon.rings, {"nome": installation.name}));
            }

        }


        ///////////////////////////////////////////////////////////////////////
        //                              Rendering
        ///////////////////////////////////////////////////////////////////////

        const rendererPoint = {
            type: "simple",  // autocasts as new SimpleRenderer()
            symbol: simboloPadraoPonto
        };

        const rendererLine = {
            type: "simple",
            symbol: {
                type: "simple-line",  // autocasts as new SimpleLineSymbol()
                color: "blue",
                width: "2px",
                marker: { // autocasts from LineSymbolMarker
                    style: "x",
                    color: "red",
                    placement: "begin"
                }
            }
        };

        const rendererPolygon = {
            type: "simple",
            symbol: {
                type: "simple-fill",  // autocasts as new SimpleFillSymbol()
                color: [ 255, 255, 255, 0.1 ],
                style: "solid",
                outline: {  // autocasts as new SimpleLineSymbol()
                    color: "blue",
                    width: 2
                }
            }
        };

        let fields = [
            {
                name: "ObjectID",
                alias: "ObjectID",
                type: "oid"
            },
            {
                name: "id",
                alias: "ID",
                type: "integer"
            },
            {
                name: "uuid",
                alias: "UUID",
                type: "string"
            },
            {
                name: "nome",
                alias: "Nome",
                type: "string"
            },
            {
                name: "activity_type",
                alias: "activity_type",
                type: "string"
            },
            {
                name: "licensing_status",
                alias: "licensing_status",
                type: "string"
            }
        ];

        ///////////////////////////////////////////////////////////////////////
        //                              Popup
        ///////////////////////////////////////////////////////////////////////


        let acaoIrParaEmpreendimento = {
            title: "Visualizar",
            id: "abrir_cadastro",
            className: "esri-icon-hollow-eye"
        };

        let template = {
            title: "Empreendimento",
            content: [{
                type: "fields",
                fieldInfos: [
                    {
                        fieldName: "id",
                        label: "ID"
                    },
                    {
                        fieldName: "uuid",
                        label: "UUID"
                    },
                    {
                        fieldName: "nome",
                        label: "Nome do Empreendimento"
                    },
                    {
                        fieldName: "activity_type",
                        label: "Tipo de Empreendimento"
                    },
                    {
                        fieldName: "licensing_status",
                        label: "Status de Licenciamento"
                    }
                ]
            }],
            actions: [acaoIrParaEmpreendimento]
        };

        function abrirCadastro() {
            const data = {
                uuid: view.popup.selectedFeature.attributes.uuid
            }
            navigate('/editenterprises', {state: data});
        }

        view.popup.on("trigger-action", function (event: { action: { id: string } }) {
            if (event.action.id === "abrir_cadastro") {
                abrirCadastro();
            }
        });


        let pointLayer = new FeatureLayer({
            title: 'Pontos',
            source: pointGraphs,
            fields: fields,
            objectIdField: "ObjectID",
            geometryType: "point",
            spatialReference: { wkid: 4326 },
            renderer: rendererPoint,
            labelingInfo: [labelClassPoint],
            popupTemplate: template
        });

        let lineLayer = new FeatureLayer({
            source: lineGraphs,
            fields: fields,
            objectIdField: "ObjectID",
            geometryType: "polyline",
            spatialReference: { wkid: 4326 },
            renderer: rendererLine,
            labelingInfo: [labelClassLine],
            popupTemplate: template
        });

        let polygonLayer = new FeatureLayer({
            source: polygonGraphs,
            fields: fields,
            objectIdField: "ObjectID",
            geometryType: "polygon",
            spatialReference: { wkid: 4326 },
            renderer: rendererPolygon,
            labelingInfo: [labelClassPolygon],
            popupTemplate: template
        });

        map.add(pointLayer, 0);
        map.add(lineLayer, 0);
        map.add(polygonLayer, 0);

        ///////////////////////////////////////////////////////////////////////
        //                       Zoom to Enterprizes
        ///////////////////////////////////////////////////////////////////////

        if(turf_features.length > 0){
            let turf_features_collection = featureCollection(turf_features);
            let collectionTurfBBox = bbox(turf_features_collection);
            let turf_polygon = bboxPolygon(collectionTurfBBox);
            let turf_expanded_polygon = buffer(turf_polygon, 1000, {units: 'meters'});
            let expdandedTurBBox = bbox(turf_expanded_polygon);

            let newExtent = new Extent({
                xmin: expdandedTurBBox[0],
                ymin: expdandedTurBBox[1],
                xmax: expdandedTurBBox[2],
                ymax: expdandedTurBBox[3],
                spatialReference: new SpatialReference({ wkid:4326 })
            });
            view.extent = newExtent;
        }


      })

      .catch((err) => console.error(err))
    //eslint-disable-next-line
  }, [props.longitude, props.latitude, props.name, props.description, props.zoom, props.duration, props.setGeomPoint, props.setGeomLine, props.setGeomPolygon, props.setGeometryType])

  return (
    <div style={styles.container}>
      <div id='viewDiv' style={styles.mapDiv}></div>{' '}
    </div>
  )
}

export {MapOneLicense}